module.exports = __webpack_public_path__ + "public/Icons/deleteIconAudio.svg?f571e0f7";